import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";

const addStakeholder = createAsyncThunk(
  "documentShow/addStakeholder",
  async (id: any, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;

      const { id: idDocument } = state.documentShow.document;
      let order = 1;
      if (state.documentShow.signers.length) {
        const lastSigner = state.documentShow.signers[state.documentShow.signers.length - 1];

        order = (lastSigner?.order || 0) + 1;
      }

      const url = new URL(`${api.baseURL}documentstakeholder`);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        body: JSON.stringify({
          document: idDocument,
          stakeholder: id,
          type: "Firmante",
          order,
        }),
        method: "POST",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export default addStakeholder;
